import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../Translations';
import { ConnectionResource } from '../../Types';
import DeleteConnection from '../DeleteConnection';

interface Props {
  resource: ConnectionResource;
}

const RemoveCard: React.FC<Props> = ({ resource }) => (
  <div>
    <h3 className="text-base font-semibold text-foreground">
      <T kind="Remove" />
    </h3>
    <div className="mt-3 rounded-lg border border-border bg-card p-6">
      <p className="text-sm text-muted-foreground">
        <T kind="Deleting removes this connection from ExecOnline. Unassign its domains first - people on them return to password sign-in." />
      </p>
      <div className="mt-3">
        <DeleteConnection resource={resource} />
      </div>
    </div>
  </div>
);

export default observer(RemoveCard);
